import {
  HelveticaBold,
  HelveticaLight,
  PoppinsSemiBold,
  PoppinsNormal,
} from "common/typographies"
import React, { useState, useEffect, useContext } from "react"
import i18n from "i18n"
import { Box, Grid } from "@material-ui/core"
import { BlueButton, CardPricing, EmptyButton } from "common/containers"
import data from "./pricing.json"
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline"
import { useNavigate } from "react-router-dom"
import AuthContext from "context/auth/authContext"
import axios from "axios"
import PropTypes from "prop-types"
import { extractChargebeePortalSession, API_URL } from "utils/functions"
import isNaN from "lodash/isNaN"

import SubscriptionContext from "context/subscription/subscriptionContext"
import PricingPage from "./PricingPage"

const SubscriptionComponent = ({ anual, setAnual }) => {
  const { subscriptionState } = useContext(SubscriptionContext)
  const [imInFreeTrial, setImInFreeTrial] = useState(false)

  const chargebeeSite = (process.env.REACT_APP_CHARGEBEE_SITE || "").trim()
  if (!window.cbInstance) {
    if (window.Chargebee && chargebeeSite) {
      window.cbInstance = window.Chargebee.init({ site: chargebeeSite })
    } else {
      const reasons = []
      if (!window.Chargebee) {
        reasons.push("window.Chargebee missing (script not loaded)")
      }
      if (!chargebeeSite) {
        reasons.push("REACT_APP_CHARGEBEE_SITE empty or unset")
      }
      console.error(
        `[SubscriptionComponent] Cannot initialize Chargebee: ${reasons.join("; ")}`,
      )
    }
  }

  useEffect(() => {
    console.log("subscriptionState", subscriptionState)
    setImInFreeTrial(subscriptionState?.subscriptions[0]?.status == "in_trial")
  }, [subscriptionState])

  const cbInstance = window.cbInstance

  const authContext = useContext(AuthContext)
  const {
    user,
    getUser,
    coupon,
    subscription,
    getCustomerInfo,
    updateChargebeeAccount,
    card,
    billingAddress,
    createChargebeePortal,
  } = authContext
  useEffect(() => {
    getCustomerInfo()
  }, [])

  useEffect(() => {
    if (!cbInstance) return
    cbInstance.setPortalSession(() =>
      createChargebeePortal().then(res => {
        const session = extractChargebeePortalSession(res)
        if (!session) {
          return Promise.reject(new Error("Invalid Chargebee portal session"))
        }
        return session
      }),
    )
  }, [cbInstance, createChargebeePortal])
  const [actualPlan, setActualPlan] = useState("")

  const [showComparativa, setShowComparativa] = useState(false)
  const navigate = useNavigate()
  useEffect(() => {
    if (subscription?.subscription_items) {
      setActualPlan(subscription.subscription_items[0].item_price_id)
    }
  }, [subscription])

  function toDateTime(secs) {
    var t = new Date(1970, 0, 1) // Epoch
    t.setSeconds(secs)
    return t
  }

  const handlePayment = (e, planName) => {
    e.preventDefault()
    if (!cbInstance) {
      console.error(
        "[SubscriptionComponent] Chargebee is not configured; checkout unavailable",
      )
      return
    }
    cbInstance.openCheckout({
      hostedPage() {
        return axios
          .post(`${API_URL}/integration/chargebee/checkout`, {
            subscriptionId: subscription.id,
            plan: planName.toUpperCase(),
            billing_period: anual ? "YEARLY" : "MONTHLY",
            coupon: [],
          })
          .then(response => response.data.checkout)
      },
      async success(hostedPageId) {
        //pasar a Arnau user.sub, planName, anual
        updateChargebeeAccount({
          email: user.email,
          plan: planName.toUpperCase(),
          billing_period: anual ? "YEARLY" : "MONTHLY",
        })
        navigate("/dashboard")
      },
      close() {
        console.log("checkout new closed")
      },
      step(step) {
        console.log("checkout", step)
      },
    })
  }
  const [itemSelected, setItemSelected] = useState(false)
  const [editSubscription, setEditSubscription] = useState(false)
  const [cancelSubscription, setCancelSubscription] = useState(false)

  const handleManageSubscription = () => {
    if (!cbInstance) {
      console.error(
        "[SubscriptionComponent] Chargebee is not configured; portal unavailable",
      )
      return
    }
    const cbPortalInstance = cbInstance.createChargebeePortal()
    cbPortalInstance.openSection(
      {
        sectionType: Chargebee.getPortalSections().SUBSCRIPTION_DETAILS,
        params: {
          subscriptionId: subscription.id,
        },
      },
      {
        visit(visit) {
          console.log("visit", visit)
        },
        subscriptionChanged(data) {
          console.log("subscription changed", data)
        },
        subscriptionCustomFieldsChanged(data) {
          console.log("subscription changed custom fields changed", data)
        },
        subscriptionCancelled(data) {
          console.log("subscription changed cancelled", data)
        },
        close() {
          location.reload()
          getCustomerInfo()
        },
      },
    )
  }

  const handleManageAddress = () => {
    if (!cbInstance) {
      console.error(
        "[SubscriptionComponent] Chargebee is not configured; portal unavailable",
      )
      return
    }
    const cbPortalInstance = cbInstance.createChargebeePortal()
    cbPortalInstance.openSection(
      {
        sectionType: Chargebee.getPortalSections().ADDRESS,
      },
      {
        visit(visit) {
          console.log("portal visit", visit)
        },
        subscriptionChanged(data) {
          console.log("subscription changed", data)
        },
        subscriptionCustomFieldsChanged(data) {
          console.log("subscription changed custom fields changed", data)
        },
        subscriptionCancelled(data) {
          console.log("subscription changed cancelled", data)
        },
        close() {
          getCustomerInfo()
        },
      },
    )
  }
  const handleBillinghistory = () => {
    if (!cbInstance) {
      console.error(
        "[SubscriptionComponent] Chargebee is not configured; portal unavailable",
      )
      return
    }
    const cbPortalInstance = cbInstance.createChargebeePortal()
    cbPortalInstance.openSection(
      {
        sectionType: Chargebee.getPortalSections().BILLING_HISTORY,
      },
      {
        visit(visit) {
          console.log("portal visit", visit)
        },
        subscriptionChanged(data) {
          console.log("subscription changed", data)
        },
        subscriptionCustomFieldsChanged(data) {
          console.log("subscription changed custom fields changed", data)
        },
        subscriptionCancelled(data) {
          console.log("subscription changed cancelled", data)
        },
        close() {
          getCustomerInfo()
        },
      },
    )
  }

  const handlePaymentSources = () => {
    if (!cbInstance) {
      console.error(
        "[SubscriptionComponent] Chargebee is not configured; portal unavailable",
      )
      return
    }
    const cbPortalInstance = cbInstance.createChargebeePortal()
    cbPortalInstance.openSection(
      {
        sectionType: Chargebee.getPortalSections().PAYMENT_SOURCES,
      },
      {
        visit(visit) {
          console.log("portal visit", visit)
        },
        subscriptionChanged(data) {
          console.log("subscriptionIII changed", data)
        },
        subscriptionCustomFieldsChanged(data) {
          console.log("subscriptioIIII changed custom fields changed", data)
        },
        subscriptionCancelled(data) {
          console.log("subscriptionIII changed cancelled", data)
        },
        close() {
          getCustomerInfo()
        },
      },
    )
  }

  const buttonCopy = plan => {
    if (user["custom:subscription_plan"] == "FREE_TRIAL") {
      if (plan == "Enterprise") {
        return i18n.t("Contactar")
      } else {
        return i18n.t("Seleccionar")
      }
    }
    let aux = actualPlan.toLowerCase()
    if (plan == "Enterprise") {
      return i18n.t("Contactar")
    }
    if (aux.includes(plan.toLowerCase())) {
      return i18n.t("Gestionar")
    } else {
      return i18n.t("Seleccionar")
    }
  }

  const [url, setUrl] = useState("")
  useEffect(() => {
    setUrl(window.location.href)
  }, [window.location.href])

  const [loading, setLoading] = useState(true)
  useEffect(() => {
    if (!user) {
      getUser()
    } else {
      if (
        user["custom:subscription_plan"] == "FREE_TRIAL" ||
        user["custom:subscription_status"] == "in_trial"
      ) {
        //setImInFreeTrial(true)
      }
      setLoading(false)
    }
  }, [user])

  return loading ? (
    <>
      <div
        style={{
          justifyContent: "center",
          width: "100%",
          textAlign: "center",
          position: "relative",
          display: "flex",
          marginLeft: "-100px",
          marginTop: "30px",
        }}
      >
        <div className="loader">
          <div className="ball"></div>
          <div className="ball"></div>
          <div className="ball"></div>
        </div>
      </div>
      <div
        style={{
          justifyContent: "center",
          width: "100%",
          textAlign: "center",
          position: "relative",
          display: "flex",
          marginLeft: "-30px",
        }}
      >
        <PoppinsNormal>{i18n.t("Cargando...")}</PoppinsNormal>
      </div>
      <div
        style={{
          justifyContent: "center",
          width: "100%",
          textAlign: "center",
          position: "relative",
          display: "flex",
          marginLeft: "-30px",
          marginTop: "-15px",
        }}
      >
        <PoppinsNormal style={{ fontWeight: "400" }}>
          {i18n.t("Esta acción puede tardar unos segundos")}
        </PoppinsNormal>
      </div>
    </>
  ) : imInFreeTrial &&
    user["custom:subscription_status"] != "cancelled" &&
    false ? (
    <>
      <PoppinsSemiBold style={{ fontSize: "20px", marginLeft: "20px" }}>
        {i18n.t("Elige las herramientas adecuadas para tu negocio")}
      </PoppinsSemiBold>
      <div
        className="inline"
        style={{
          width: "100%",
          justifyContent: "center",
          marginBottom: "30px",
          marginTop: "-20px",
        }}
      >
        <div className="container4buttons">
          {anual == false ? (
            <>
              <BlueButton
                style={{
                  width: "123px",
                  marginLeft: "-4px",
                  height: "26px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginTop: "2px",
                  borderRadius: "4px",
                }}
              >
                <HelveticaLight
                  style={{
                    color: "white",
                    paddingTop: "12px",
                    fontSize: "13px",
                    fontWeight: "700",
                  }}
                >
                  {i18n.t("Mensual")}
                </HelveticaLight>
              </BlueButton>
              <EmptyButton
                style={{ marginTop: "4px", paddingLeft: "2px" }}
                onClick={() => {
                  navigate("/subscriptionAnual")
                  history.go(0)
                }}
              >
                <HelveticaLight
                  style={{
                    color: "rgba(65, 65, 65, 0.75)",
                    paddingTop: "12px",
                    fontSize: "13px",
                    fontWeight: "400",
                  }}
                >
                  {i18n.t("Anual - Ahorra un 20%")}
                </HelveticaLight>
              </EmptyButton>
            </>
          ) : (
            <>
              <EmptyButton
                style={{ marginTop: "4px", paddingLeft: "2px", with: "123px" }}
                onClick={() => {
                  navigate("/subscription")
                  history.go(0)
                }}
              >
                <HelveticaLight
                  style={{
                    color: "rgba(65, 65, 65, 0.75)",
                    paddingTop: "12px",
                    fontSize: "13px",
                    fontWeight: "400",
                  }}
                >
                  {i18n.t("Mensual")}
                </HelveticaLight>
              </EmptyButton>
              <BlueButton
                style={{
                  width: "160px",
                  zIndex: "3",
                  marginLeft: "-4px",
                  height: "26px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginTop: "2px",
                  borderRadius: "4px",
                }}
              >
                <HelveticaLight
                  style={{
                    color: "white",
                    paddingTop: "12px",
                    fontSize: "12px",
                    fontWeight: "700",
                  }}
                >
                  {i18n.t("Anual - Ahorra un 20%")}
                </HelveticaLight>
              </BlueButton>
            </>
          )}
        </div>
      </div>

      <div
        className="inline"
        style={{
          justifyContent: "center",
          width: "100%",
          marginLeft: "auto",
          marginRight: "auto",
        }}
      >
        <Box position="relative" zIndex={2}>
          <Grid
            container
            spacing={4}
            justifyContent="center"
            style={{ display: "flex-grid" }}
          >
            {data.map((item, index) => {
              return (
                <Grid item xs={4} key={index}>
                  <CardPricing>
                    <div
                      style={{
                        width: "100%",
                        position: "relative",
                        display: "flex",
                        textAlign: "center",
                        justifyContent: "center",
                      }}
                    >
                      <HelveticaBold
                        style={{
                          fontSize: "20px",
                          color: "#414141",
                          marginTop: "20px",
                          textTransform: "uppercase",
                        }}
                      >
                        {item.externalName}
                      </HelveticaBold>
                    </div>
                    <div
                      style={{
                        width: "100%",
                        height: "1px",
                        backgroundColor: "rgba(0, 0, 0, 0.05)",
                        marginBottom: "18px",
                      }}
                    ></div>
                    <div style={{ marginLeft: "20px" }}>
                      {anual == false ? (
                        <>
                          {!isNaN(item.monthlyPrice) ? (
                            <div className="inline">
                              <HelveticaBold
                                style={{
                                  fontSize: "42px",
                                  color: "#414141",
                                  marginTop: "-15px",
                                }}
                              >
                                {item.monthlyPrice} €
                              </HelveticaBold>
                              <HelveticaBold
                                style={{
                                  fontSize: "18px",
                                  color: "#414141",
                                  marginTop: "10px",
                                }}
                              >
                                {" "}
                                &nbsp; por usuario/mes
                              </HelveticaBold>
                            </div>
                          ) : (
                            <HelveticaBold
                              style={{
                                fontSize: "42px",
                                color: "#414141",
                                marginTop: "-15px",
                              }}
                            >
                              {i18n.t("Consultar")}
                            </HelveticaBold>
                          )}

                          {item.mostPopular ? (
                            <BlueButton
                              style={{
                                cursor: "default",
                                width: "110px",
                                height: "20px",
                                marginTop: "-100px",
                                marginLeft: "145px",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                position: "absolute",
                              }}
                            >
                              <HelveticaLight
                                style={{
                                  color: "white",
                                  paddingTop: "12px",
                                  fontSize: "14px",
                                  fontWeight: "600",
                                }}
                              >
                                {i18n.t("Mas popular")}
                              </HelveticaLight>
                            </BlueButton>
                          ) : null}
                        </>
                      ) : (
                        <>
                          {!isNaN(item.monthlyPrice) ? (
                            <HelveticaLight
                              style={{
                                fontSize: "16px",
                                fontWeight: "400",
                                textDecoration: "line-through",
                              }}
                            >
                              {item.monthlyPrice} €
                            </HelveticaLight>
                          ) : (
                            <div style={{ height: "25px" }}></div>
                          )}

                          {!isNaN(item.yearlyPrice) ? (
                            <div className="inline">
                              <HelveticaBold
                                style={{
                                  fontSize: "42px",
                                  color: "#414141",
                                  marginTop: "-15px",
                                }}
                              >
                                {Math.trunc(parseFloat(item.yearlyPrice) / 12)}{" "}
                                €
                              </HelveticaBold>
                              <HelveticaBold
                                style={{
                                  fontSize: "18px",
                                  color: "#414141",
                                  marginTop: "10px",
                                }}
                              >
                                &nbsp; por usuario/mes{" "}
                              </HelveticaBold>
                            </div>
                          ) : (
                            <HelveticaBold
                              style={{
                                fontSize: "42px",
                                color: "#414141",
                                marginTop: "0px",
                              }}
                            >
                              {i18n.t("Consultar")}
                            </HelveticaBold>
                          )}
                        </>
                      )}
                    </div>

                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        position: "relative",
                        justifyContent: "center",
                        marginBottom: "30px",
                      }}
                    >
                      {item.planName == "Professional" ? (
                        <BlueButton
                          onClick={() =>
                            window.open(
                              "https://calendly.com/planhopper-xvq/planhopper",
                              "_blank",
                            )
                          }
                          style={{
                            width: "260px",
                            height: "40px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            backgroundColor:
                              buttonCopy(item.planName) == "Gestionar" &&
                              "#ffd52b",
                          }}
                        >
                          <HelveticaLight
                            style={{
                              color: "white",
                              paddingTop: "12px",
                              fontSize: "14px",
                              fontWeight: "600",
                              color:
                                buttonCopy(item.planName) == "Gestionar"
                                  ? "black"
                                  : "white",
                            }}
                          >
                            {buttonCopy(item.planName)}
                          </HelveticaLight>
                        </BlueButton>
                      ) : (
                        <BlueButton
                          onClick={e => {
                            handlePayment(e, item.planName)
                          }}
                          style={{
                            width: "260px",
                            height: "40px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            backgroundColor:
                              buttonCopy(item.planName) == "Gestionar" &&
                              "#ffd52b",
                          }}
                        >
                          <HelveticaLight
                            style={{
                              color: "white",
                              paddingTop: "12px",
                              fontSize: "14px",
                              fontWeight: "600",
                              color:
                                buttonCopy(item.planName) == "Gestionar"
                                  ? "black"
                                  : "white",
                            }}
                          >
                            {buttonCopy(item.planName)}
                          </HelveticaLight>
                        </BlueButton>
                      )}
                    </div>

                    <div
                      style={{
                        width: "100%",
                        height: "1px",
                        backgroundColor: "rgba(0, 0, 0, 0.05)",
                        marginBottom: "30px",
                      }}
                    ></div>
                    {item.mainFeatures.map((feature, index) => {
                      return (
                        <div
                          style={{
                            marginLeft: "25px",
                            marginBottom: "15px",
                            marginTop: "-10px",
                          }}
                          className="inline"
                          key={index}
                        >
                          <CheckCircleOutlineIcon
                            style={{
                              color: "#414141",
                              width: "18px",
                              heigth: "18px",
                              marginTop: "-2px",
                              marginRight: "10px",
                            }}
                          />
                          <HelveticaBold
                            style={{
                              color: "#414141",
                              fontSize: "14px",
                              fontWeight: "400",
                            }}
                          >
                            {feature}
                          </HelveticaBold>
                        </div>
                      )
                    })}
                  </CardPricing>
                </Grid>
              )
            })}
          </Grid>
        </Box>
      </div>
    </>
  ) : (
    <>
      <PricingPage />
    </>
  )
}

SubscriptionComponent.propTypes = {
  anual: PropTypes.bool,
  setAnual: PropTypes.func,
}

export default SubscriptionComponent
